import { useTranslation } from 'react-i18next';
import IconEmpty from '../../../assets/Images/icons/empty';

export default function DisplayDPIA({ dpiaOwner }) {
    const { t } = useTranslation();
    return (
        <div className="col-span-1 bg-white h-max rounded-xl p-4 py-6 my-4">
            <div
                className="text-[17px] font-semibold pb-2"
                style={{ borderBottom: '3px solid #F4F6FC' }}
            >
                {t('Data Protection Impact Assessment Owner')}
            </div>
            <div className="my-2">
                {dpiaOwner.length > 0 ? (
                    <div>
                        <div className="mb-2 font-semibold text-[#65707A]">
                            {t('TotalItems', {
                                length: dpiaOwner.length,
                            })}
                        </div>
                        <div className="overflow-auto max-h-[200px]">
                            {dpiaOwner.map((item) => (
                                <div key={item.dpiaId} className="mb-2">
                                    <div className="flex bg-[#F5F6FF] px-4 py-2 rounded-md">
                                        <p className="mb-0">{item.dpiaName}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                    <div className="grid items-center justify-center">
                        <IconEmpty />
                    </div>
                )}
            </div>
        </div>
    );
}
